import React from 'react';

import Intro from 'features/common/Intro';
import Main from 'components/UI/Main';
import Bullets from 'features/common/Bullets';
import TechnologiesGrid from 'features/common/TechnologiesGrid';
import WhatWeDo from 'features/common/WhatWeDo';
import { Calculator } from 'components/Calculator';
import Industries from 'features/common/Industries';
import ContactUs from 'features/common/ContactUs';
import SEO from 'components/SEO';

import data from './data.json';

export default function CrossPlatformDevelopment() {
  return (
    <>
      <Intro {...data.intro} />
      <Main paddingDisable="top">
        <Bullets {...data.feature} />
        <TechnologiesGrid {...data.expertise} />
        <WhatWeDo {...data.whatWeDo} />
        <Calculator type="service" />
        <Industries {...data.customSolutions} />
        <ContactUs {...data.getConsultation} />
      </Main>
    </>
  );
}

export const Head = ({ location }) => <SEO {...data.head} {...location} />;
